import { apiFetch } from '@/api/client'

const multipart = { 'Content-Type': 'multipart/form-data' }

export const settingsApi = {
  generalSettings: () => apiFetch('general-settings'),
  // Laravel method spoofing, kept as the backend expects it.
  updateGeneralSettings: (payload) =>
    apiFetch('general-settings/1', {
      method: 'POST',
      body: { ...payload, _method: 'PUT' },
      headers: multipart,
    }),

  roles: ({ signal } = {}) => apiFetch('roles', { signal }),
  role: (id) => apiFetch(`roles/${id}`),
  deleteRole: (id) => apiFetch(`roles/${id}`, { method: 'DELETE' }),
  createRole: (payload) => apiFetch('roles', { method: 'POST', body: payload }),
  updateRole: (payload) =>
    apiFetch(`roles/${payload.id}`, { method: 'PUT', body: { ...payload, _method: 'PUT' } }),

  createBlog: (payload) => apiFetch('blogs', { method: 'POST', body: payload, headers: multipart }),
  updateBlog: (id, payload) =>
    apiFetch(`blogs/${id}`, { method: 'POST', body: payload, headers: multipart }),
  deleteBlog: (id) => apiFetch(`blogs/${id}`, { method: 'DELETE' }),

  modules: ({ signal } = {}) => apiFetch('modules', { signal }),
  toggleModuleStatus: (payload, bulk = false) =>
    apiFetch(`modules/${bulk ? payload.id + '/bulk-update' : payload.id}`, {
      method: 'PUT',
      body: payload,
    }),

  usersWithGlobalRoles: (params) => apiFetch('users', { params }),
  updateUserRoleVisibility: (userId, payload) =>
    apiFetch(`users/${userId}/role-visibility`, { method: 'POST', body: payload }),
}
